export const DEFAULT_AGENDA_INTERVAL = 30;
export const DEFAULT_AGENDA_SIZE = 45;
export const DEFAULT_AGENDA_SIZE_FOR_NEW_USERS = 45;

let agendaDurationInterval = DEFAULT_AGENDA_INTERVAL;
let agendaLineSize = DEFAULT_AGENDA_SIZE;
let agendaPointsPerMinOffset = 1.5;
let agendaLineSizeClassName = 'timeSlotContainer45';

export function setAgendaLayoutConfig(agendaLayoutConfig) {
  agendaDurationInterval = agendaLayoutConfig?.durationInterval ?? DEFAULT_AGENDA_INTERVAL;
  agendaLineSize = agendaLayoutConfig?.lineSize ?? DEFAULT_AGENDA_SIZE;
  agendaPointsPerMinOffset = agendaLineSize / agendaDurationInterval;
  agendaLineSizeClassName = `timeSlotContainer${agendaLineSize}`;
}

export function getAgendaDurationInterval() {
  return agendaDurationInterval;
}

export function getAgendaLineSize() {
  return agendaLineSize;
}

export function getAgendaLineSizeClassName() {
  return agendaLineSizeClassName;
}

export function getAgendaPointsPerMinOffset() {
  return agendaPointsPerMinOffset;
}
